import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { resetSearchFlights } from '@shared/redux/actions';

const FlightTypeSelector = ({
  dispatch,
  searchType,
  searchPax,
  flightClass,
  airSectionRow,
}) => {
  const theme = useTheme();

  const handleChange = event => {
    const newType = event.target.value;
    const lastValue = searchType;

    if (lastValue == 'MultipleFlights' && newType != 'MultipleFlights') {
      const airSave = {
        destination: airSectionRow[0]?.destination || {},
        origin: airSectionRow[0]?.origin || {},
      };
      airSectionRow.forEach(el => {
        el.destination = {};
        el.origin = {};
      });
      if (airSectionRow[0])
        airSectionRow[0] = {
          ...airSectionRow[0],
          ...airSave,
        };
      if (airSectionRow[1])
        airSectionRow[1] = {
          ...airSectionRow[1],
          origin: airSave.destination,
          destination: airSave.origin,
        };
    }

    dispatch(
      resetSearchFlights({
        trip_type: newType,
        shouldReset: true,
        searchPax,
        flightClass,
        airSectionRow,
      })
    );
  };

  const options = useMemo(
    () => [
      { value: 'RoundTrip', label: 'Ida y vuelta' },
      { value: 'OneWay', label: 'Solo ida' },
      { value: 'MultipleFlights', label: 'Múltiples destinos' },
    ],
    []
  );

  const radioControl = (
    <Radio
      sx={{
        '&.Mui-checked': {
          color: theme.tertiary,
        },
      }}
    />
  );

  return (
    <FormControl component="fieldset">
      <RadioGroup
        row
        aria-label="tipo de viaje"
        name="trip-type"
        value={searchType}
        onChange={handleChange}
      >
        {options.map(option => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={radioControl}
            label={option.label}
            componentsProps={{
              typography: {
                sx: {
                  fontSize: { xs: '14px', sm: '16px' },
                  color: '#636466',
                },
              },
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default FlightTypeSelector;
